import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Box from "@mui/material/Box"
import Tooltip from "@mui/material/Tooltip"

import { EFormModule } from "../.."
import MultiSelectDropdown from "../../../../components/MultiSelectDropdown/MultiSelectDropdown"
import RadioGroup from "../../../../components/RadioGroup/RadioGroup"
import SearchInputV2 from "../../../../components/SearchInputV2/SearchInputV2"
import { EAccountRole } from "../../../../enums/commonEnums"
import validationError from "../../../../enums/validationError"
import AddAccounts from "../../../../pages/Accounts/features/AddAccounts"
import MuiAutoComplete from "../../../MuiAutocomplete"
import CountrySelectField from "../../../MuiCountrySelect"
import MuiModal from "../../../MuiModal"
import VirtualizedSearchSelect from "../../../VirtualizedSearchSelect"
import Sites from "./Sites/Sites"
import { useAccountLocation } from "./useAccountLocation"

import { faCirclePlus } from "@fortawesome/sharp-solid-svg-icons"
import { faAngleDown } from "@fortawesome/sharp-thin-svg-icons"
import add_icon from "../../../../assets/images/add_icon_n.svg"
import delete_red from "../../../../assets/images/delete_red.svg"
import error_mark from "../../../../assets/images/error_mark.svg"

import ProjectFormFooter from "components/ProjectForm/components/ProjectFormFooter"
import styles from "../../RaiseTicketForm.module.scss"

type Props = {
    handleNextStep: () => void
    handleCloseForm: () => void
    is_solo_edit?: boolean
    setSiteValue?: any
    module: EFormModule
}
const AccountLocation = (props: Props) => {
    const {
        formik,
        statesList,
        citiesList,
        newlyAddedSite,
        nextClicked,
        setNextClicked,
        handleChangeSelectType,
        showAddAccountModal,
        setShowAddAccountModal,
        accountRolesOptions,
        selectedAccountRoles,
        setSelectedAccountRoles,
        handleRemoveAccountRole,
        isAccountsLoading,
        handleLoadMoreAccounts,
        accountsList,
        handleAccountSearch,
        accountFormMap,
        handleSelectAccount,
        selectedAccountMap,
        showEditAccountModal,
        openEditAccountModal,
        closeEditAccountModal,
        handleSelectBillingAddress,
        handleSelectBillingContact,
        showDemolitionAddSites,
        setShowDemolitionAddSites,
        siteOptions,
        isSitesLoading,
        handleSearchSites,
        handleLoadMoreSites,
        handleNext,
        showDemolitionsErrors,
        sourceSite,
        setSourceSite,
        destinationSite,
        setDestinationSite,
        showSiteTable,
        setShowSiteTable,
        user_data,
    } = useAccountLocation({
        module: props.module,
        handleNextStep: props.handleNextStep,
    })

    const siteType = formik.values.siteType

    const handleSiteChange = (siteId: any) => {
        if (props?.module === EFormModule.PROJECTS) {
            if (showSiteTable.type === "source") {
                setSourceSite({
                    id: siteId,
                    title: siteOptions.find(option => option.id === siteId)?.title || "",
                })
                formik.setFieldValue("sourceSite", siteId)
            } else {
                setDestinationSite({
                    id: siteId,
                    title: siteOptions.find(option => option.id === siteId)?.title || "",
                })
                formik.setFieldValue("destinationSite", siteId)
            }
            setShowSiteTable({ isShown: false, type: null })
        } else {
            props.setSiteValue?.(siteId)
        }
    }
    const hasAccountDetails = props?.module === EFormModule.DEMOLITION || props?.module === EFormModule.EV_APPLICATION
    const isShowInfo = user_data.role_id !== 1 && user_data.role_id !== 51
    const isSurveyModule = props.module === EFormModule.SURVEYS
    

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div
                    className={`${styles.page_container} ${props?.module === EFormModule.PROJECTS ? "p-16" : ""}`}
                    style={{
                        maxHeight: hasAccountDetails ? 650 : 500,
                        minHeight: hasAccountDetails ? "none" : 400,
                        overflow: "auto",
                    }}>
                    {hasAccountDetails && (
                        <Box display={"flex"} flexDirection={"column"} gap={"16px"}>
                            <Box className={styles.form_title} paddingBottom={"0px !important"}>
                                ACCOUNT DETAILS
                            </Box>

                            <Box display={"flex"} gap={"16px"} flexDirection={"column"}>
                                <Box display={"flex"} gap={"8px"} flexDirection={"column"}>
                                    <Box fontSize={"14px"} fontWeight={500} color={"#0430C0"}>
                                        Select New Account Role
                                    </Box>
                                    <Box width={"25%"}>
                                        <MuiAutoComplete
                                            options={accountRolesOptions}
                                            placeholder="Select Account Role"
                                            onChange={(value: any) => setSelectedAccountRoles(value)}
                                            value={selectedAccountRoles}
                                            multiple={true}
                                            disableClearable
                                        />
                                        {/* <MultiSelectDropdown
                                            hideSelectAll
                                            options={accountRolesOptions}
                                            title="Select Account Role"
                                            onSelect={(value: any) => setSelectedAccountRoles(value)}
                                            selectedOptions={selectedAccountRoles}
                                            selectionType="multiple"
                                        /> */}
                                    </Box>
                                </Box>
                            </Box>

                            <Box
                                display={"flex"}
                                gap={"12px"}
                                padding={"12px"}
                                flexDirection={"column"}
                                bgcolor={"#FAFAFA"}
                                borderRadius={"8px"}>
                                <Box fontSize={"12px"} fontWeight={500} textTransform={"uppercase"}>
                                    Buyer Account
                                </Box>
                                <Box display={"flex"} gap={"12px"}>
                                    <Box display={"flex"} gap={"8px"} flexDirection={"column"} flex={1}>
                                        <Box
                                            display={"flex"}
                                            justifyContent={"space-between"}
                                            alignItems={"center"}
                                            fontSize={"14px"}
                                            fontWeight={500}>
                                            Account Name*
                                            <Tooltip title="Add New Account">
                                                <img
                                                    src={add_icon}
                                                    alt=""
                                                    height={"14px"}
                                                    width={"14px"}
                                                    onClick={() => setShowAddAccountModal(true)}
                                                />
                                            </Tooltip>
                                        </Box>
                                        <VirtualizedSearchSelect
                                            height="29px"
                                            fontSize="10px"
                                            placeholder="Select Account"
                                            options={accountsList}
                                            loading={isAccountsLoading}
                                            onSearch={handleAccountSearch}
                                            onLoadMore={handleLoadMoreAccounts}
                                            onChange={(value: any) => {
                                                handleSelectAccount(EAccountRole.BUYER, value.id)
                                            }}
                                            selectedOption={accountFormMap[EAccountRole.BUYER]?.accountId}
                                            error={" "}
                                            showError={
                                                showDemolitionsErrors && !accountFormMap[EAccountRole.BUYER]?.accountId
                                            }
                                        />
                                    </Box>
                                    <Box display={"flex"} gap={"8px"} flexDirection={"column"} flex={1}>
                                        <Box
                                            display={"flex"}
                                            justifyContent={"space-between"}
                                            alignItems={"center"}
                                            fontSize={"14px"}
                                            fontWeight={500}>
                                            Billing Address*
                                            {accountFormMap[EAccountRole.BUYER]?.accountId && (
                                                <Tooltip title="Add New Billing Address">
                                                    <img
                                                        src={add_icon}
                                                        alt=""
                                                        height={"14px"}
                                                        width={"14px"}
                                                        onClick={() => openEditAccountModal(EAccountRole.BUYER)}
                                                    />
                                                </Tooltip>
                                            )}
                                        </Box>
                                        <Box>
                                            <MuiAutoComplete
                                                options={
                                                    selectedAccountMap[EAccountRole.BUYER]?.billing_addresses?.map(
                                                        i => ({
                                                            id: i.id,
                                                            title: `${i.address}, ${i.city}, ${i.state}, ${i.pincode}`,
                                                        })
                                                    ) || []
                                                }
                                                placeholder="Select Billing Address"
                                                onChange={(value: any) => {
                                                    handleSelectBillingAddress(EAccountRole.BUYER, value?.id)
                                                }}
                                                value={accountFormMap[EAccountRole.BUYER]?.billingAddress}
                                                disabled={!accountFormMap[EAccountRole.BUYER]?.accountId}
                                                error={
                                                    showDemolitionsErrors &&
                                                    !accountFormMap[EAccountRole.BUYER]?.billingAddress
                                                }
                                            />
                                        </Box>
                                    </Box>
                                    <Box display={"flex"} gap={"8px"} flexDirection={"column"} flex={1}>
                                        <Box
                                            display={"flex"}
                                            justifyContent={"space-between"}
                                            alignItems={"center"}
                                            fontSize={"14px"}
                                            fontWeight={500}>
                                            Contact*
                                            {accountFormMap[EAccountRole.BUYER]?.accountId && (
                                                <Tooltip title="Add New Contact">
                                                    <img
                                                        src={add_icon}
                                                        alt=""
                                                        height={"14px"}
                                                        width={"14px"}
                                                        onClick={() => openEditAccountModal(EAccountRole.BUYER)}
                                                    />
                                                </Tooltip>
                                            )}
                                        </Box>
                                        <Box>
                                            <MuiAutoComplete
                                                options={
                                                    selectedAccountMap[EAccountRole.BUYER]?.account_contacts?.map(
                                                        i => ({
                                                            id: i.id,
                                                            title: `${i.name} - ${i.phone}`,
                                                        })
                                                    ) || []
                                                }
                                                placeholder="Select Contact"
                                                onChange={(value: any) => {
                                                    handleSelectBillingContact(EAccountRole.BUYER, value?.id)
                                                }}
                                                value={accountFormMap[EAccountRole.BUYER]?.billingContact}
                                                disabled={!accountFormMap[EAccountRole.BUYER]?.accountId}
                                                error={
                                                    showDemolitionsErrors &&
                                                    !accountFormMap[EAccountRole.BUYER]?.billingContact
                                                }
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>

                            {selectedAccountRoles.length > 0 &&
                                selectedAccountRoles.map(role => (
                                    <Box
                                        key={role.id}
                                        display={"flex"}
                                        gap={"12px"}
                                        padding={"12px"}
                                        flexDirection={"column"}
                                        bgcolor={"#FAFAFA"}
                                        borderRadius={"8px"}>
                                        <Box
                                            fontSize={"12px"}
                                            fontWeight={500}
                                            display={"flex"}
                                            gap={"8px"}
                                            textTransform={"uppercase"}
                                            alignItems={"center"}>
                                            {role.title} Account
                                            <img
                                                src={delete_red}
                                                alt=""
                                                height={"14px"}
                                                width={"14px"}
                                                onClick={() => handleRemoveAccountRole(role.id)}
                                            />
                                        </Box>
                                        <Box display={"flex"} gap={"12px"}>
                                            <Box display={"flex"} gap={"8px"} flexDirection={"column"} flex={1}>
                                                <Box
                                                    fontSize={"14px"}
                                                    fontWeight={500}
                                                    display={"flex"}
                                                    justifyContent={"space-between"}
                                                    alignItems={"center"}>
                                                    {role.title} Name*
                                                    <Tooltip title="Add New Account">
                                                        <img
                                                            src={add_icon}
                                                            alt=""
                                                            height={"14px"}
                                                            width={"14px"}
                                                            onClick={() => setShowAddAccountModal(true)}
                                                        />
                                                    </Tooltip>
                                                </Box>
                                                <VirtualizedSearchSelect
                                                    height="29px"
                                                    fontSize="10px"
                                                    placeholder="Select Account"
                                                    options={accountsList}
                                                    loading={isAccountsLoading}
                                                    onSearch={handleAccountSearch}
                                                    onLoadMore={handleLoadMoreAccounts}
                                                    onChange={(value: any) => {
                                                        handleSelectAccount(role.id, value.id)
                                                    }}
                                                    selectedOption={accountFormMap[role.id]?.accountId}
                                                    error={" "}
                                                    showError={
                                                        showDemolitionsErrors && !accountFormMap[role.id]?.accountId
                                                    }
                                                />
                                            </Box>
                                            <Box display={"flex"} gap={"8px"} flexDirection={"column"} flex={1}>
                                                <Box
                                                    fontSize={"14px"}
                                                    fontWeight={500}
                                                    display={"flex"}
                                                    justifyContent={"space-between"}
                                                    alignItems={"center"}>
                                                    Billing Address*
                                                    {accountFormMap[role.id]?.accountId && (
                                                        <Tooltip title="Add New Billing Address">
                                                            <img
                                                                src={add_icon}
                                                                alt=""
                                                                height={"14px"}
                                                                width={"14px"}
                                                                onClick={() => openEditAccountModal(role.id)}
                                                            />
                                                        </Tooltip>
                                                    )}
                                                </Box>
                                                <Box>
                                                    <MuiAutoComplete
                                                        options={
                                                            selectedAccountMap[role.id]?.billing_addresses?.map(i => ({
                                                                id: i.id,
                                                                title: `${i.address}, ${i.city}, ${i.state}, ${i.pincode}`,
                                                            })) || []
                                                        }
                                                        placeholder="Select Billing Address"
                                                        onChange={(value: any) => {
                                                            handleSelectBillingAddress(role.id, value?.id)
                                                        }}
                                                        value={accountFormMap[role.id]?.billingAddress || null}
                                                        error={
                                                            showDemolitionsErrors &&
                                                            !accountFormMap[role.id]?.billingAddress
                                                        }
                                                        disabled={!accountFormMap[role.id]?.accountId}
                                                    />
                                                </Box>
                                            </Box>
                                            <Box display={"flex"} gap={"8px"} flexDirection={"column"} flex={1}>
                                                <Box
                                                    fontSize={"14px"}
                                                    fontWeight={500}
                                                    display={"flex"}
                                                    justifyContent={"space-between"}
                                                    alignItems={"center"}>
                                                    Contact*
                                                    {accountFormMap[role.id]?.accountId && (
                                                        <Tooltip title="Add New Contact">
                                                            <img
                                                                src={add_icon}
                                                                alt=""
                                                                height={"14px"}
                                                                width={"14px"}
                                                                onClick={() => openEditAccountModal(role.id)}
                                                            />
                                                        </Tooltip>
                                                    )}
                                                </Box>
                                                <Box>
                                                    <MuiAutoComplete
                                                        options={
                                                            selectedAccountMap[role.id]?.account_contacts?.map(i => ({
                                                                id: i.id,
                                                                title: `${i.name} - ${i.phone}`,
                                                            })) || []
                                                        }
                                                        placeholder="Select Contact"
                                                        onChange={(value: any) => {
                                                            handleSelectBillingContact(role.id, value?.id)
                                                        }}
                                                        value={accountFormMap[role.id]?.billingContact || null}
                                                        disabled={!accountFormMap[role.id]?.accountId}
                                                        error={
                                                            showDemolitionsErrors &&
                                                            !accountFormMap[role.id]?.billingContact
                                                        }
                                                    />
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                ))}
                        </Box>
                    )}
                    <div className={styles.page_section}>
                        <div className={styles.form_title}>
                            {props?.module === "logistics" && "DESTINATION"} SITE DETAILS
                            {hasAccountDetails && !showDemolitionAddSites && (
                                <Box
                                    className="cursor-pointer"
                                    display={"flex"}
                                    alignItems={"center"}
                                    gap={"4px"}
                                    color={"#70758D"}
                                    onClick={() => {
                                        setShowDemolitionAddSites(true)
                                        formik.unregisterField("siteType")
                                    }}>
                                    <FontAwesomeIcon icon={faCirclePlus} className="" />
                                    Add new site
                                </Box>
                            )}
                        </div>

                        {hasAccountDetails ? (
                            <Box display={"flex"} gap={"16px"} marginBottom={"16px"}>
                                <Box width={"40%"} display={"flex"} flexDirection={"column"} gap={"8px"}>
                                    <Box
                                        fontSize={"14px"}
                                        fontWeight={500}
                                        display={"flex"}
                                        justifyContent={"space-between"}
                                        alignItems={"center"}>
                                        {props?.module !== EFormModule.EV_APPLICATION ? "Source Site*" : "Select Site*"}
                                    </Box>
                                    {props?.module === EFormModule.PROJECTS ? (
                                        <Box
                                            onClick={() => setShowSiteTable({ isShown: true, type: "source" })}
                                            color="#70758d"
                                            height={"29px"}
                                            fontSize="11px"
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="space-between"
                                            borderBottom={"1px solid #e5e7eb"}
                                            padding={"0 8px"}
                                            bgcolor="rgba(232, 232, 236, 0.2)"
                                            sx={{
                                                cursor: "pointer",
                                            }}>
                                            {sourceSite?.id ? (
                                                <Box>{sourceSite.title}</Box>
                                            ) : (
                                                <Box>Select Source Site</Box>
                                            )}
                                            <FontAwesomeIcon icon={faAngleDown} />
                                        </Box>
                                    ) : (
                                        <VirtualizedSearchSelect
                                            height="29px"
                                            fontSize="10px"
                                            placeholder="Select Source Site"
                                            options={siteOptions}
                                            loading={isSitesLoading}
                                            onSearch={handleSearchSites}
                                            onLoadMore={handleLoadMoreSites}
                                            selectedOption={sourceSite}
                                            onChange={(value: any) => {
                                                setSourceSite(value)
                                            }}
                                            error={" "}
                                            showError={showDemolitionsErrors && !sourceSite}
                                        />
                                    )}
                                </Box>
                                {props?.module !== EFormModule.EV_APPLICATION && (
                                    <Box width={"40%"} display={"flex"} flexDirection={"column"} gap={"8px"}>
                                        <Box
                                            fontSize={"14px"}
                                            fontWeight={500}
                                            display={"flex"}
                                            justifyContent={"space-between"}
                                            alignItems={"center"}>
                                            Destination Site*
                                        </Box>
                                        {props?.module === EFormModule.PROJECTS ? (
                                            <Box
                                                onClick={() => setShowSiteTable({ isShown: true, type: "destination" })}
                                                color="#70758d"
                                                height={"29px"}
                                                fontSize="11px"
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="space-between"
                                                borderBottom={"1px solid #e5e7eb"}
                                                padding={"0 8px"}
                                                bgcolor="rgba(232, 232, 236, 0.2)"
                                                sx={{
                                                    cursor: "pointer",
                                                }}>
                                                {destinationSite?.id ? (
                                                    <Box>{destinationSite.title}</Box>
                                                ) : (
                                                    <Box>Select Destination Site</Box>
                                                )}
                                                <FontAwesomeIcon icon={faAngleDown} />
                                            </Box>
                                        ) : (
                                            <VirtualizedSearchSelect
                                                height="29px"
                                                fontSize="10px"
                                                placeholder="Select Destination Site"
                                                options={siteOptions}
                                                loading={isSitesLoading}
                                                onSearch={handleSearchSites}
                                                onLoadMore={handleLoadMoreSites}
                                                selectedOption={destinationSite}
                                                onChange={(value: any) => {
                                                    setDestinationSite(value)
                                                }}
                                                error={" "}
                                                showError={showDemolitionsErrors && !destinationSite}
                                            />
                                        )}
                                    </Box>
                                )}
                            </Box>
                        ) : (
                            <>
                                <div className="weight-500 text-md my-2 mb-2">
                                    Select Site Type*
                                    {formik.values.siteType?.id === undefined && <img src={error_mark} alt="" />}
                                </div>
                                <RadioGroup
                                    options={[
                                        ...(isSurveyModule || user_data?.role_id === 1 || user_data?.role_id === 51
                                            ? [{ id: 1, title: "New" }]
                                            : []),
                                        { id: 0, title: "Existing" },
                                    ]}
                                    onSelect={(value: any) => handleChangeSelectType(value)}
                                    value={formik.values.siteType}
                                    labelsStyle={{ display: "grid", gridTemplateColumns: "35% 40%" }}
                                />
                            </>
                        )}

                        <div className={styles.section_body}>
                            {(siteType?.title === "New" || (hasAccountDetails && showDemolitionAddSites)) && (
                                <div
                                    className="m-4 p-15"
                                    style={{
                                        background: "#FAFAFA",
                                    }}>
                                    <div className="weight-500 text-md my-2 mb-10"> NEW SITE</div>

                                    <div className={`${styles.form_section} d-flex gap-20`}>
                                        <div className="width-100p">
                                            <div className={styles.section_header}>Country*</div>
                                            <CountrySelectField
                                                value={formik.values.country}
                                                onChange={(val: any) => formik.setFieldValue("country", val)}
                                                required={true}
                                                showError={!!formik.touched.country}
                                            />
                                        </div>
                                        <div className="width-100p">
                                            <div className={styles.section_header}>Site Name*</div>
                                            <SearchInputV2
                                                placeholder="Enter Name"
                                                onSearch={(val: any) => formik.setFieldValue("siteName", val)}
                                                value={formik.values.siteName}
                                                error={!!formik.touched.siteName && !!formik.errors.siteName}
                                                showError={!!formik.touched.siteName}
                                            />
                                        </div>
                                        <div className="width-100p">
                                            <div className={styles.section_header}>Site Address*</div>
                                            <SearchInputV2
                                                placeholder="Enter Address"
                                                onSearch={(val: any) => formik.setFieldValue("siteAddress", val)}
                                                value={formik.values.siteAddress}
                                                error={!!formik.touched.siteAddress && !!formik.errors.siteAddress}
                                                showError={!!formik.touched.siteAddress}
                                            />
                                        </div>
                                    </div>

                                    <div className={`${styles.form_section} d-flex gap-20`}>
                                        <div className="width-100p">
                                            <div className={styles.section_header}>Pincode</div>
                                            <SearchInputV2
                                                placeholder="Enter Pincode"
                                                onSearch={(val: any) => formik.setFieldValue("pincode", val)}
                                                value={formik.values.pincode}
                                                error={!!formik.touched.pincode && !!formik.errors.pincode}
                                                showError={!!formik.touched.pincode}
                                                type="number"
                                                maxCharacter={formik.values.country?.id === 101 ? 6 : 20}
                                                errorText={
                                                    formik.values.country?.id === 101 ? validationError.PINCODE : ""
                                                }
                                            />
                                        </div>

                                        <div className="width-100p">
                                            <div className={styles.section_header}>State</div>
                                            <MultiSelectDropdown
                                                title="Select State"
                                                options={statesList?.map(state => ({
                                                    id: state?.id,
                                                    title: state?.name,
                                                }))}
                                                id="state"
                                                selectionType="single"
                                                selectedOptions={formik.values.state ? [formik.values.state] : []}
                                                onSelect={(value: any) => formik.setFieldValue("state", value)}
                                                error={!formik.values.state?.id}
                                                showError={!formik.values.state?.id}
                                                disabled={!formik.values.country?.id}
                                            />
                                        </div>

                                        <div className="width-100p">
                                            <div className={styles.section_header}>City</div>
                                            <MultiSelectDropdown
                                                title="Select City"
                                                options={citiesList?.map(city => ({
                                                    id: city?.id,
                                                    title: city?.name,
                                                }))}
                                                id="cities"
                                                selectedOptions={formik.values.city ? [formik.values.city] : []}
                                                onSelect={(value: any) => formik.setFieldValue("city", value)}
                                                selectionType="single"
                                                error={!formik.values.city?.id}
                                                showError={!formik.values.city?.id}
                                                disabled={!formik.values.state?.id}
                                            />
                                        </div>
                                    </div>

                                    <div className="weight-500 text-md">Coordinates</div>
                                    <div className={`${styles.form_section} d-flex gap-20`}>
                                        <div className="width-100p">
                                            <SearchInputV2
                                                placeholder="Latitude"
                                                onSearch={(val: any) => formik.setFieldValue("latitude", val)}
                                                value={formik.values.latitude}
                                                error={!!formik.touched.latitude && !!formik.errors.latitude}
                                                showError={!!formik.touched.latitude}
                                                errorText={validationError.LATITUDE}
                                            />
                                        </div>
                                        <div className="width-100p">
                                            <SearchInputV2
                                                placeholder="Longitude"
                                                onSearch={(val: any) => formik.setFieldValue("longitude", val)}
                                                value={formik.values.longitude}
                                                error={!!formik.touched.longitude && !!formik.errors.longitude}
                                                showError={!!formik.touched.longitude}
                                                errorText={validationError.LONGITUDE}
                                            />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-end w-100">
                                        {hasAccountDetails && (
                                            <button
                                                type="button"
                                                className="raise-ticket-form__footer-button cancel-btn"
                                                onClick={() => {
                                                    setShowDemolitionAddSites(false)
                                                }}>
                                                Cancel
                                            </button>
                                        )}

                                        <button type="submit" className="raise-ticket-form__footer-button next-btn">
                                            Save
                                        </button>
                                    </div>
                                </div>
                            )}
                            
                            {(siteType?.title === "Existing" || showSiteTable.isShown) && (
                                <Sites
                                    formik={formik}
                                    preSelectedSite={newlyAddedSite}
                                    nextClicked={nextClicked}
                                    setNextClicked={setNextClicked}
                                    setSiteValue={handleSiteChange}
                                    showInfoMsg={isShowInfo}
                                    isSurveyModule={isSurveyModule}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </form>

            <MuiModal
                open={showAddAccountModal}
                header="Please enter the details"
                onClose={() => setShowAddAccountModal(false)}
                width={"671px"}
                maxHeight={"80vh"}>
                <AddAccounts toggle={() => setShowAddAccountModal(false)} isShown={showAddAccountModal} />
            </MuiModal>

            {showEditAccountModal.isShown && (
                <MuiModal
                    open={showEditAccountModal.isShown}
                    header="Please enter the details"
                    onClose={() => closeEditAccountModal()}
                    width={"671px"}
                    maxHeight={"80vh"}>
                    <AddAccounts
                        toggle={() => closeEditAccountModal()}
                        ticketData={selectedAccountMap[showEditAccountModal.role!]!}
                        editFlag={true}
                        isShown={showEditAccountModal.isShown}
                    />
                </MuiModal>
            )}

            {props.module === EFormModule.PROJECTS ? (
                <ProjectFormFooter handleCloseForm={props.handleCloseForm} handleSubmit={handleNext} />
            ) : (
                <footer className="raise-ticket-form__footer">
                    <button className="raise-ticket-form__footer-button cancel-btn" onClick={props.handleCloseForm}>
                        Cancel
                    </button>
                    <button className="raise-ticket-form__footer-button next-btn" type="button" onClick={handleNext}>
                        Next
                    </button>
                </footer>
            )}
        </>
    )
}

export default AccountLocation
